var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _vm._l(_vm.galleries, function(galleryGroup, index) {
        return _vm.model.groups && _vm.model.groups.length
          ? _c("div", [
              _c("h2", [_vm._v(_vm._s(galleryGroup.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "table__column" }, [
                  _c(
                    "div",
                    { staticClass: "table--monthly" },
                    _vm._l(galleryGroup.galleryGroups, function(column) {
                      return _c(
                        "div",
                        { class: _vm.imgRowClass },
                        _vm._l(column, function(item) {
                          return _c("div", { staticClass: "table__column" }, [
                            !item.imgUrl
                              ? _c("div", { staticClass: "blog__img" })
                              : _vm._e(),
                            _vm._v(" "),
                            item.imgUrl
                              ? _c("img", {
                                  staticClass: "blog__img",
                                  attrs: { src: item.imgUrl }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "gallery__img-hover" }, [
                              _c("h3", [_vm._v(_vm._s(item.title))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "gallery__img-hover__footer" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button button--secondary",
                                      on: {
                                        click: function($event) {
                                          _vm.showLightbox(item.images)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        VAATA KÕIKI PILTE\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        })
                      )
                    })
                  )
                ])
              ])
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      !_vm.model.groups || (_vm.model.groups && !_vm.model.groups.length)
        ? _c("div", { staticClass: "row" }, [
            _c("h3", [_vm._v("Otsingule vastavaid pilte ei leitud ")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row pagination__container" }, [
        _c("div", [
          _c(
            "button",
            {
              class: _vm.nextButtonClass,
              attrs: { type: "button" },
              on: { click: _vm.next }
            },
            [_vm._v("\n                LAE VANEMAID PILTE\n            ")]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75fd2818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75fd2818","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/GallerySlider/GallerySlider.vue
// module id = 527
// module chunks = 3